// Security #2/#3: fetch an S3 object WITHOUT any IAM credentials in the browser.
//
// The old implementation built an aws-sdk S3 client in the browser using an
// access key / secret key (with a hardcoded fallback key — finding #3) and did
// getObject directly. That exposed long-lived IAM credentials to every user.
//
// New model: ask the backend (auth-gated, finding #1) for a short-lived presigned
// GET URL for this one object, then fetch it. No credentials ever reach the client.
// The returned value is the same Blob the callers already expect, so nothing
// downstream changes.
import gql from 'graphql-tag';
import client from '../../config/ApolloClient';

const GET_S3_PRESIGNED_URL = gql`
  query getS3PresignedUrl($objectKey: String!) {
    getS3PresignedUrl(objectKey: $objectKey)
  }
`;

// Accepts the legacy payload shape ({ url, ...ignored }) — only `url` (the S3 key)
// is used now; any leftover accessKey/region/secretKey are ignored and unnecessary.
export default async ({ url }) => {
  if (!url) throw new Error('readFileFromS3: object key (url) is required');

  const { data } = await client.query({
    query: GET_S3_PRESIGNED_URL,
    variables: { objectKey: url },
    fetchPolicy: 'no-cache', // never cache signed URLs; they expire
  });

  const signedUrl = data && data.getS3PresignedUrl;
  if (!signedUrl) throw new Error('readFileFromS3: no presigned URL returned');

  const response = await fetch(signedUrl);
  if (!response.ok) throw new Error(`readFileFromS3: S3 fetch failed HTTP ${response.status}`);
  return response.blob();
};
